import { Table, Button, Card, ConfigProvider, Empty } from "antd";
import React, { useState, useEffect, useRef } from "react";
import { requestOrderList, cancelSubscription } from "@/services/api";
import RenewalModal from "./components/RenewalModal";
// import { ORDER_STATUS } from '../../../../constant/order';
import { connect } from "react-redux";
import moment from "moment";
import "./index.less";

/**
 * 订单状态常量
 */
const ORDER_STATUS = {
  0: "待支付",
  1: "已付款",
  2: "部分退款",
  3: "全额退款",
  4: "chargeback",
  5: "退款中",
  6: "已过期",
  8: "取消CB",
  9: "退款失败",
};

/**
 * 订单信息组件
 * @returns
 */
const OrderList = (props) => {
  const [tableLoading, setTableLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  /**
   * 自动续费弹窗的ref对象
   */
  const renewalModalRef = useRef();

  useEffect(() => {
    getOrderData();
    document.title = "订单信息-个人中心";
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute("content", "牛学长产品订单信息");
    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", "查询已购买的牛学长产品订单信息");
  }, []);

  //获取订单信息
  const getOrderData = async () => {
    setTableLoading(true);
    let newResult = [];
    try {
      const { code, data } = await requestOrderList("niu", {
        page: 1,
        limit: 10000,
        site_id: 93,
      });
      if (code === 200 && data) {
        data.map((ele, index) => {
          ele.goods.map((item) => {
            item.order_id = ele.id;
            item.original_custom_oid = ele.original_custom_oid;
            item.invoice_url = ele.invoice_url;
            item.is_renew = ele.is_renew;
            item.status = ele.status;
            item.create_time = ele.create_time;
            item.expire_time = ele.expire_time;
            item.order_no = ele.order_no;
            item.order_price = ele.order_price;
            item.platform_name = ele.platform_name;
            item.amount = ele?.renew?.amount;
            item.next_bill_time = ele?.renew?.next_bill_time;
            newResult.push({ ...item, key: index });
          });
        });
        setTableData(newResult);
        setTableLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      title: "订单编号",
      dataIndex: "original_custom_oid",
      key: "original_custom_oid",
      width: 180,
      render: (_, option) => {
        return (
          <span style={{ wordWrap: "break-word", wordBreak: "break-word" }}>
            {option.original_custom_oid}
          </span>
        );
      },
    },
    {
      title: "产品名",
      dataIndex: "name",
      key: "name",
      width: 160,
    },
    {
      title: "套餐类型",
      dataIndex: "license_name",
      align: "center",
      width: 110,
      key: "license_name",
      render: (_, option) => {
        const { license_info } = option;
        //判断当前订单是否购买的是捆绑套餐，如果是，套餐类型直接展示"捆绑套餐"
        if (option?.is_bind) {
          return "捆绑套餐";
        }
        return license_info.cycle === 0
          ? "终生套餐"
          : license_info.cycle === 1
          ? "月版套餐"
          : license_info.cycle === 3
          ? "季版套餐"
          : license_info.cycle == 12
          ? "年版套餐"
          : "其他年版套餐";
      },
    },
    {
      title: "购买时间",
      dataIndex: "create_time",
      align: "center",
      width: 130,
      key: "create_time",
      render: (_, option) => {
        return moment(parseInt(option.create_time) * 1000).format("YYYY-MM-DD");
      },
    },
    // {
    //     title: '到期时间',
    //     dataIndex: 'expire_time',
    //     align: 'center',
    //     key: 'expire_time',
    //     width: 106,
    //     render: (_, option) => {
    //         return moment(parseInt(option.expire_time) * 1000).format('YYYY-MM-DD')
    //     }
    // },
    {
      title: "订单金额",
      dataIndex: "order_price",
      align: "center",
      key: "order_price",
      width: 100,
    },
    {
      title: "支付方式",
      dataIndex: "platform_name",
      align: "center",
      width: 120,
    },
    {
      title: "状态",
      dataIndex: "status",
      align: "center",
      key: "option",
      width: 96,
      render: (_, option) => {
        return ORDER_STATUS[option.status];
      },
    },
    {
      title: "操作",
      dataIndex: "options",
      align: "center",
      width: 96,
      render: (_, option) => {
        const { status, invoice_url } = option;
        if (status === 1) {
          return invoice_url ? (
            <a
              className="btn btn-outline-primary option-btn"
              href={option.invoice_url}
            >
              查看发票
            </a>
          ) : (
            <a className="btn btn-primary btn-sm option-btn">开票中</a>
          );
        } else if (status === 6) {
          return "";
        }
      },
    },
  ];

  //管理自动续费
  const filterRenewaloOrder = () => {
    renewalModalRef?.current?.setRenewalModalVisible();
  };

  /**
   * 自定义table表格的空状态
   * @returns
   */
  // const customizeRenderEmpty = () => (
  //   <div
  //     style={{ textAlign: "center", display: "flex", justifyContent: "center" }}
  //   >
  //     <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  //   </div>
  // );

  return (
    <>
      <Card
        title="订单信息"
        bordered={false}
        className="order_card w-100"
        headStyle={{ border: 0, fontWeight: 700, paddingBottom: 24 }}
        // extra={
        //   <span
        //     className="small text-primary automatic-renewal"
        //     onClick={filterRenewaloOrder}
        //   >
        //     管理自动续费
        //   </span>
        // }
      >
        {/* <ConfigProvider renderEmpty={customizeRenderEmpty}> */}
        <Table
          rowKey="key"
          columns={columns}
          dataSource={tableData}
          loading={tableLoading}
          pagination={{
            defaultCurrent: 1,
            total: tableData.length,
          }}
          rowClassName={(_, index) => {
            return index % 2 === 0 ? "oddRow" : "eventRow";
          }}
          className="orderTable"
          bordered
        />
        {/* </ConfigProvider> */}
      </Card>

      {/* 管理自动续费弹窗组件 */}
      <RenewalModal
        ref={renewalModalRef}
        handleReloadTable={getOrderData} //刷新表格数据
      />
    </>
  );
};

const mapStateToPropos = (state) => {
  return {
    authorization: state.account.authorization,
    currentUserInfo: state.account.currentUserInfo,
  };
};
export default connect(mapStateToPropos)(OrderList);
